import { Card } from "react-bootstrap";
import styled from "styled-components";

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;

  border-bottom: 1px solid #e5e5e5;
`;

export const StyledTranslationCard = styled(Card)`
  .flag-icon-es-eu {
    background-image: url("https://s3.eu-central-1.amazonaws.com/witbooking.static/img/ikurrina.png");
    background-size: 28px;
  }

  .nav-tabs .errorTab .nav-link.active {
    background-color: #fbb4ac;
    border: 1px solid #fb6d81;
  }
  .errorTab {
    > a {
      background-color: #fbb4ac;
      border: 1px solid #fb6d81;
    }
  }
`;

export const StyledContainer = styled.div`
  width: fit-content;
`;

export const ErrorField = styled.div`
  width: 100%;
  margin: 0.5rem 0;
  background-color: #f5abba;
  border-radius: 5px;
  padding: 2px 5px;
  color: #6e0218;
`;
